import { render } from "./registration-signup.vue?vue&type=template&id=46c13a85&scoped=true"
import script from "./registration-signup.vue?vue&type=script&lang=js"
export * from "./registration-signup.vue?vue&type=script&lang=js"

import "./registration-signup.vue?vue&type=style&index=0&id=46c13a85&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c13a85"]])

export default __exports__